import { StorageType, StorageService } from './local-storage.interface';

const sessionKey = 'session';
const testKey = 'storage-test-key';
const testValue = 'storage-test-value';

export class LocalStorage implements StorageService {
  storageType: StorageType = StorageType.LocalStorage;

  getItem(key: string): string {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(keepSession: boolean): void {
    if (keepSession) {
      const session = this.getItem(sessionKey);
      localStorage.clear();
      if (session) {
        this.setItem(sessionKey, session);
      }
    } else {
      localStorage.clear();
    }
  }

  isSupported(): boolean {
    try {
      localStorage.setItem(testKey, testValue);
      const storeSuccessful = localStorage.getItem(testKey) === testValue;
      localStorage.removeItem(testKey);
      return storeSuccessful;
    } catch (e) {
      return false;
    }
  }
}
